import {InjectionToken} from '@angular/core';

export interface PaymentRedirect {
  goToProductsOrWaiterPage(): void;
  goToTicketPage(ticketId: string): void;
}

export const PAYMENT_REDIRECT = new InjectionToken<PaymentRedirect>('PAYMENT_REDIRECT');
